import { OrderLinePackedVo } from "./order-line-packed-vo";

export class OrderPackedState {
    public  packedList: OrderLinePackedVo[] = [];
    public orderLineList: OrderLinePackedVo[] = [];
}